export default __webpack_public_path__ + "static/media/4、首页有气草本.803f0956.jpg";